import { render, staticRenderFns } from "./RELKmTempoReal.vue?vue&type=template&id=643c04ea&"
import script from "./RELKmTempoReal.vue?vue&type=script&lang=js&"
export * from "./RELKmTempoReal.vue?vue&type=script&lang=js&"
import style0 from "./RELKmTempoReal.vue?vue&type=style&index=0&id=643c04ea&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports